var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.195,
    height: 14.5,
    viewBox: "0 0 13.195 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(-702.354 -1110.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share_1_",
    "data-name": "share (1)",
    transform: "translate(679.305 1110.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(23.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M33.866,9.744a2.374,2.374,0,0,0-1.868.91L27.633,8.135a2.37,2.37,0,0,0,0-1.769L32,3.846a2.372,2.372,0,1,0-.338-.583L27.3,5.782a2.378,2.378,0,1,0,0,2.936l4.364,2.52a2.377,2.377,0,1,0,2.206-1.493Zm0-9.07a1.7,1.7,0,1,1-1.7,1.7A1.706,1.706,0,0,1,33.866.674ZM25.427,8.954a1.7,1.7,0,1,1,1.7-1.7A1.706,1.706,0,0,1,25.427,8.954Zm8.439,4.872a1.7,1.7,0,1,1,1.7-1.7A1.706,1.706,0,0,1,33.866,13.826Z",
    transform: "translate(-23.049)",
    fill: "#143340"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(24.424 6.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M72.619,220.606a1,1,0,0,0-1,1,.337.337,0,0,0,.674,0,.328.328,0,0,1,.328-.328.337.337,0,1,0,0-.674Z",
    transform: "translate(-71.617 -220.606)",
    fill: "#143340"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5f416ae2c5bf07e796c8f6f497615e7f.svg";
export { ForwardRef as ReactComponent };